import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ChevLeftIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M14 8L10 12L14 16" stroke={fillColor || '#111112'} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export { ChevLeftIcon };
